import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import some from "lodash/some";
import { OnboardingIntroExperimentVariant } from "../../../constants/onboarding-intro-experiment-variant.enum";
import type { ISurveyInputWithKey } from "../../../legacy/pages/survey/entities/survey-input-with-key/survey-input-with-key.interface";

export const ONBOARDING_INTRO_EXPERIMENT_PAYLOAD_KEY = "profileData.onboardingExperiment";

export const onboardingIntroExperimentValueAtom = atom<"true" | "false" | null>(null);

// Mobile app entry (/mobile-onboarding): the native app consumes the welcome edge,
// so the intro is served at route level; this marker keeps the survey from re-serving it.
export const mobileOnboardingIntroServedAtom = atomWithStorage<boolean>("bx_mobile_onboarding_intro_served", false);

export function toOnboardingIntroExperimentFeelValue(variant: OnboardingIntroExperimentVariant): "true" | "false" {
  const isIntroScreenVariant = variant === OnboardingIntroExperimentVariant.INTRO_SCREEN;
  return isIntroScreenVariant ? "true" : "false";
}

const WELCOME_STEP_MARKER_INPUT_NAME = "welcomePrivacyCondition";

export function isOnboardingWelcomeStep(inputs: readonly ISurveyInputWithKey[]): boolean {
  return some(inputs, function hasWelcomeMarkerInput(input) {
    return input.remoteInput?.name === WELCOME_STEP_MARKER_INPUT_NAME;
  });
}
